import { apiGet } from "./apiClient";
import { apiPost } from "./apiClient";
import { apiPatch } from "./apiClient";

export function getAccountsByInstitutionId(institutionId) {
    return apiGet(`/bank-accounts/institutions/${institutionId}`);
}

export function getAccountsForAdmin(institutionId) {
    return apiGet(`/bank-accounts/admin/institutions/${institutionId}`);
}


export function getAccountsOfHead(institutionId) {
    return apiGet(`/bank-accounts/head/${institutionId}`);
}

export function getInstitutionWalletsAccounts(institutionId) {
    return apiGet(`/bank-accounts/by-wallets/${institutionId}`);
}

export async function getBankAccountD(bankAccountId) {
  const response = await apiGet(`/bank-accounts/${bankAccountId}`);
  return response;
}

export async function getBankAccountWalletSnapShots(bankAccountId, params = {}) {
  const query = new URLSearchParams({
    // timeFrame: params.timeFrame || "DAILY",
    ...(params.startDate && { startDate: params.startDate }),
    ...(params.endDate && { endDate: params.endDate }),
  }).toString();

  const response = await apiGet(
    // `/bank-accounts/wallet-snapshots/${bankAccountId}?${query}`
    `/bank-accounts/bank-report-statement-snapshots/${bankAccountId}?${query}`
  );

  return response;
}

export async function getBankAccountBalanceSnapShots(bankAccountId, params = {}) {
  const query = new URLSearchParams({
    // timeFrame: params.timeFrame || "DAILY",
    ...(params.startDate && { startDate: params.startDate }),
    ...(params.endDate && { endDate: params.endDate }),
  }).toString();

  const response = await apiGet(
    // `/bank-accounts/balance-snapshots/${bankAccountId}?${query}`
    `/bank-accounts/bank-statement-snapshots/${bankAccountId}?${query}`
  );

  return response;
}

export async function syncBankBalances() {
  return apiPost("/bank-accounts/sync-balance");
}

export async function syncSnapshotBalances() {
  return apiPost("/snapshot/backfill/all");
}

export async function syncSnapshotAccountWallet(accountId) {
  return apiPost(`/snapshot/backfill/${accountId}`);
}

export async function activateAccount(bankAccountId) {
  return apiPatch(`/bank-accounts/activate/${bankAccountId}`);
}

export async function deactivateAccount(bankAccountId) {
  return apiPatch(`/bank-accounts/deactivate/${bankAccountId}`);
}

export async function updateAccount(bankAccountId, payload) {
  return apiPatch(`/bank-accounts/${bankAccountId}`, payload);
}

export async function createBankAccount(payload) {
  const response = await apiPost("/bank-accounts", payload);
  return response.data;
}